// @ts-nocheck
import { fabric } from 'fabric';
import _ from 'lodash';
import { DEFAULT_FONT } from '../../../config';
import { convertBeatTypeNumberToText, isDeleteBeatMode } from '../../../ui/helper';

let BeatIndicator;

(function () {
  const STROKE_DELETE = {
    strokeWidth: 1,
    selectable: false,
    hasBorders: false,
    stroke: '#F23D42',
    originX: 'center',
    originY: 'center',
  };

  const STROKE_ADD = {
    strokeWidth: 1,
    selectable: false,
    hasBorders: false,
    stroke: '#0B68E5',
    originX: 'center',
    originY: 'center',
  };

  const BEAT_COLOR = {
    N: '#9DA7B2',
    S: '#E08789',
    V: '#E09663',
    Q: '#A097CC',
  };

  BeatIndicator = function (cv: any, config: any, beatTypeNumber: any) {
    this.type = 'BeatIndicator';
    this.canvas = cv;
    this.config = config;
    this.beatTypeNumber = beatTypeNumber;
    this.x = -10;
  };

  BeatIndicator.prototype.draw = function () {
    const type = convertBeatTypeNumberToText(this.beatTypeNumber);
    this.line = new fabric.Line(
      [this.x, 0, this.x, this.config.height],
      isDeleteBeatMode(this.beatTypeNumber) ? STROKE_DELETE : STROKE_ADD,
    );
    this.line.id = 'bi';
    this.canvas.add(this.line);
    // Beat shape
    const startY = 12;
    this.polyline = new fabric.Polyline(
      [
        { x: 8, y: 0 },
        { x: 8, y: 10 },
        { x: 4, y: 14 },
        { x: 0, y: 10 },
        { x: 0, y: 0 },
      ],
      {
        top: startY,
        left: this.x,
        stroke: BEAT_COLOR[type],
        fill: BEAT_COLOR[type],
        selectable: false,
        strokeLineJoin: 'round',
        strokeWidth: 2,
        originX: 'center',
        originY: 'center',
        visible: !isDeleteBeatMode(this.beatTypeNumber),
      },
    );
    this.canvas.add(this.polyline);
    this.beatText = new fabric.IText(type, {
      fontFamily: DEFAULT_FONT,
      fontSize: 10,
      selectable: false,
      hasControls: false,
      hasBorders: false,
      hasRotatingPoint: false,
      selection: false,
      skipTargetFind: false,
      editable: false,
      width: 5,
      top: startY + 0.5,
      left: this.x,
      fill: 'white',
      originX: 'center',
      originY: 'center',
      visible: !isDeleteBeatMode(this.beatTypeNumber),
    });
    this.canvas.add(this.beatText);
    this.render();
  };

  BeatIndicator.prototype.update = function ({ point, beatTypeNumber, visible }: any) {
    if (point) {
      this.x = point.x;
      this.line.set({ x1: this.x, x2: this.x });
      this.line.setCoords();
      this.polyline.set({ left: this.x });
      this.polyline.setCoords();
      this.beatText.set({ left: this.x });
      this.beatText.setCoords();
    }
    if (beatTypeNumber) {
      this.beatTypeNumber = beatTypeNumber;
      const type = convertBeatTypeNumberToText(this.beatTypeNumber);
      this.line.set({ ...(isDeleteBeatMode(this.beatTypeNumber) ? STROKE_DELETE : STROKE_ADD) });
      this.polyline.set({
        visible: !isDeleteBeatMode(this.beatTypeNumber),
        stroke: BEAT_COLOR[type],
        fill: BEAT_COLOR[type],
      });
      this.beatText.set({ text: type, visible: !isDeleteBeatMode(this.beatTypeNumber) });
      this.canvas.bringToFront(this.polyline);
      this.canvas.bringToFront(this.beatText);
    }
    if (!_.isNil(visible)) {
      this.polyline.set({ visible: visible ? !isDeleteBeatMode(this.beatTypeNumber) : false });
      this.beatText.set({ visible: visible ? !isDeleteBeatMode(this.beatTypeNumber) : false });
      this.line.set({ visible });
      this.canvas.bringToFront(this.polyline);
      this.canvas.bringToFront(this.beatText);
    }
    this.render();
  };

  BeatIndicator.prototype.render = function () {
    this.canvas.renderAll();
  };

  BeatIndicator.prototype.delete = function () {
    this.canvas.remove(this.line);
    this.canvas.remove(this.polyline);
    this.canvas.remove(this.beatText);
    this.line = null;
    this.polyline = null;
    this.beatText = null;
  };
})();

export { BeatIndicator };
export default { BeatIndicator };
